import BadgeEarn from "components/badge-earn/badge-earn";

export default BadgeEarn;
